////
/// @group Utility
////

/** IOverlayGrid Interface */
export interface IOverlayGrid {
  /** Element selectors object. */
  el: {
    root: HTMLElement
    button: HTMLButtonElement
  }

  /** Classes object. */
  classes: {
    show: {
      root: string
      button: string
    }
  }
  /** Initializes the overlay grid. */
  init: () => void

  /** Handles the button click event. */
  handleButton: () => void

  /** Shows the overlay grid.*/
  show: () => void

  /** Hides the overlay grid. */
  hide: () => void
}

/**
 * @description Overlay grid helper to visualize the website grid.
 * @returns IOverlayGrid
 */
export const overlayGrid: IOverlayGrid = {
  el: {
    root: document.querySelector<HTMLElement>('.overlay-grid'),
    button: document.querySelector<HTMLButtonElement>('.overlay-grid__button'),
  },
  classes: {
    show: {
      root: 'overlay-grid--show',
      button: 'overlay-grid__button--active',
    },
  },

  init(): void {
    this.handleButton()
    // this.show()
  },

  handleButton(): void {
    if (this.el.button) {
      this.el.button.addEventListener(
        'click',
        (e: Event & { target: HTMLButtonElement }) => {
          e.preventDefault
          if (!this.el.root.classList.contains(this.classes.show.root)) {
            this.show()
          } else {
            this.hide()
          }
        }
      )
    }
  },
  show(): void {
    this.el.root.classList.add(this.classes.show.root)
    this.el.button.classList.add(this.classes.show.button)
  },
  hide(): void {
    this.el.root.classList.remove(this.classes.show.root)
    this.el.button.classList.remove(this.classes.show.button)
  },
}
